import { Component, OnInit, Input, ElementRef, Renderer, forwardRef } from '@angular/core';
import { BaseEditor } from '../baseEditor/base.editor'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import * as moment from 'moment'

@Component({
	selector: 'ixs-date',
	templateUrl: 'date.component.html',
    styleUrls:['date.css'],
	providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateComponent),
            multi: true
        }
    ]
})

export class DateComponent implements ControlValueAccessor {
	  selectedItem: any[];


    constructor(private element: ElementRef, private renderer: Renderer) {


    }

    //for the purpose of fire event on lister select event
    public triggerChanged() {
		
        let event = new CustomEvent('change', { bubbles: true });
        this.renderer.invokeElementMethod(this.element.nativeElement, 'dispatchEvent', [event]);
    }

    private innerValue: any = '';

    private onTouchedCallback: () => void;
    private onChangeCallback: (_: any) => void;


  

    get value(): any {
		
		
       const rtnVal : string  =  moment( this.innerValue).format( 'YYYY-MM-DD');
		return rtnVal;
	
	
    };

	@Input()
    set value(v: any) {
        if (v !== this.innerValue && v !== null) {
			
            this.innerValue = v;
            this.onChangeCallback(v);

        }
    }

    onBlur() {
        
        this.onTouchedCallback();
    }

    writeValue(value: any) {
		
         if(!value) {
            this.innerValue = '';
        }
        else
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
        
    }

    registerOnChange(fn: any) {
		
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }


    @Input()
    caption: string

    @Input()
    disabled: boolean = false;



}


// WEBPACK FOOTER //
// ./src/app/components/date/date.component.ts